export const authInputClassName =
  "font-inter h-11 w-full rounded-lg border border-[#757682] bg-white px-3.5 text-sm text-[#1f2937] outline-none placeholder:text-[#757682] focus:border-[#f19500]";

export const authPrimaryButtonClassName =
  "font-inter flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-[#f19500] text-sm font-semibold text-white shadow-[0px_1px_1px_rgba(0,0,0,0.05)] transition hover:bg-[#e08600] disabled:cursor-not-allowed disabled:opacity-50";

export const authCardClassName =
  "w-full max-w-[647px] rounded-2xl border border-[#c5c5d3] bg-white p-6 shadow-[0px_1px_1px_rgba(0,0,0,0.05)] sm:p-8";

export const authLabelClassName = "font-inter text-sm font-semibold leading-5 text-[#1f2937]";
